var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"popup"}},[_c('div',{staticClass:"box rounded-b-xl"},[_c('p',{staticClass:"pa-3 ma-0"},[_vm._v(_vm._s(_vm.content.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }